export enum FilterLabels {
  ALL = 'All',
  PRODUCT = 'Product',
  RESOURCE = 'Resources',
  DISCUSSIONS = 'Discussions',
  VIDEOS = 'Videos',
  ARTICLES = 'Articles',
  REAL_LIFE_STORIES = 'Real Life Stories',
}
